import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RemoteDeviceType } from '@store';

@Component({
  selector: 'app-zigbee-topology-device',
  templateUrl: './zigbee-topology-device.component.html',
  styleUrls: ['./zigbee-topology-device.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZigbeeTopologyDeviceComponent {
  RemoteDeviceType = RemoteDeviceType;

  @Input() name: string;
  @Input() displayName: string = null;
  @Input() key: string;
  @Input() lqiTotal: number = null;
  @Input() rx: number = null;
  @Input() tx: number = null;
  @Input() deviceDescription: string = null;
  @Input() businessName: string;
  @Input() gatewayId: string = null;
  @Input() roomName: string = null;
  @Input() connectionStatus: string = null;
}
